import "./App.css";
import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Home from "./components/Home/Home";
import ProfileForm from "./components/Dashboard/ProfileForm";
import SearchInterviews from "./components/Dashboard/SearchInterviews";
import Dashboard from "./components/Dashboard/Dashboard";
import Login from "./components/Home/Login";
import Signupstudent from "./components/Home/Signupstudent";
import Signupprofessional from "./components/Home/Signupprofessional";
import SentRequests from "./components/Dashboard/SentRequests";
import HowItWorksStudents from "./components/Home/HowitWorksStudents";
import HowItWorksProfessionals from "./components/Home/HowitWorksProfessionals";
import UpcomingInterviews from "./components/Dashboard/UpcomingInterviews";
import AcceptedRequests from "./components/Dashboard/AcceptedRequests";
import CompletedInterviews from "./components/Dashboard/CompletedInterviews";
import Interviewer from "./components/Interviewer/Interviewer";
// import CanceledInterviews from "./components/Dashboard/sub-section/CanceledInterviews";
// import DeclinedRequests from "./components/Dashboard/sub-section/DeclinedRequests";
import Issue from "./components/Dashboard/ReportIssue";
import axios from "axios";
import ReportInterviewer from "./components/Dashboard/ReportIssueInterviewer";
import Reschedule from "./components/Dashboard/Reschedule";
import ICancel from "./components/Dashboard/ICancel";
import SCancel from "./components/Dashboard/SCancel";
import ReportIssue from "./components/Dashboard/ReportIssue";
import FAQstudent from "./components/Home/FAQstudent";
import FAQProfessional from "./components/Home/FAQProfessional";
import Std2Int from "./components/Dashboard/Std2Int";
import Test from "./components/Dashboard/popups/Test";
import Dump from "./dump";
import Int2Std from "./components/Interviewer/Int2Std";
import HomeRoutes from "./components/Home/HomeRoutes";
import { FAQS_PROFESSIONAL_ROUTE, FAQS_STUDENTS_ROUTE, HOW_IT_WORKS_PROFESSIONALS_ROUTE, HOW_IT_WORKS_STUDENTS_ROUTE } from "./constants/routes";

function App() {
  const [user, setUser] = useState();
  useEffect(() => {
    async function fetchUser() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/auth/login/g/success`,
          { withCredentials: true }
        );
        window.localStorage.setItem(
          "isAuthenticated",
          JSON.stringify(data.user)
        );
        setUser(data.user);
        // console.log(localStorage.getItem("isIAuthenticated"));
      } catch (error) {
        console.log(error);
      }
    }
    fetchUser();
  }, [user]);
  //   useEffect(() => {
  //     async function fetchUser() {
  //       try {
  //         const { data } = await axios.get(
  //           "http://localhost:8585/auth/login/f/success",
  //           { withCredentials: true }
  //         );
  //         setUser(data.user);
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //     fetchUser();
  //   }, []);
  //   useEffect(() => {
  //     async function fetchUser() {
  //       try {
  //         const { data } = await axios.get(
  //           "http://localhost:8585/auth/login/l/success",
  //           { withCredentials: true }
  //         );
  //         setUser(data.user);
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //     fetchUser();
  //   }, []);
  //   /**=========================================================== */
  useEffect(() => {
    async function fetchUser() {
      try {
        const { data } = await axios.get(
          "http://localhost:4545/i/auth/i/login/g/success",
          { withCredentials: true }
        );
        console.log(data.user);
        setUser(data.user);
        window.localStorage.setItem(
          "isIAuthenticated",
          JSON.stringify(data.user)
        );
        console.log(localStorage.getItem("isIAuthenticated"));
      } catch (error) {
        console.log(error);
      }
    }
    fetchUser();
  }, []);
  //   useEffect(() => {
  //     async function fetchUser() {
  //       try {
  //         const { data } = await axios.get(
  //           "http://localhost:4545/i/auth/i/login/f/success",
  //           { withCredentials: true }
  //         );
  //         setInterviewer(data.user);
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //     fetchUser();
  //   }, []);
  //   useEffect(() => {
  //     async function fetchUser() {
  //       try {
  //         const { data } = await axios.get(
  //           "http://localhost:4545/i/auth/i/login/l/success",
  //           { withCredentials: true }
  //         );
  //         setInterviewer(data.user);
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //     fetchUser();
  //   }, []);

  return (
    <div className="App" style={{paddingTop: "70px"}}>
      <Helmet>
        <title>Interwiu</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <Login />
      <Signupstudent />
      <Signupprofessional />
      <Routes>
        <Route path={FAQS_STUDENTS_ROUTE} element={<FAQstudent />} />
        <Route path={FAQS_PROFESSIONAL_ROUTE} element={<FAQProfessional />} />
        <Route path={HOW_IT_WORKS_STUDENTS_ROUTE} element={<HowItWorksStudents />} />
        <Route path={HOW_IT_WORKS_PROFESSIONALS_ROUTE} element={<HowItWorksProfessionals />} />
        <Route path="/*" element={<HomeRoutes />} />
        {/* <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact2" element={<Contact2 />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/" element={<Home />} /> */}
        <Route path="/search" element={<SearchInterviews />} />
        {/* <Route
          path="/"
          element={
            localStorage.getItem("isAuthenticated") !== null ? (
              <SearchInterviews />
            ) : (
              <Home />
            )
          }
        /> */}
        <Route
          path="/sent-requests"
          element={
            localStorage.getItem("isAuthenticated") !== null ? (
              <SentRequests />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/accepted-requests"
          element={
            localStorage.getItem("isAuthenticated") !== null ? (
              <AcceptedRequests />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/upcoming-interviews"
          element={
            localStorage.getItem("isAuthenticated") !== null ? (
              <UpcomingInterviews />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/completed-interviews"
          element={
            localStorage.getItem("isAuthenticated") !== null ? (
              <CompletedInterviews />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/profile-form"
          element={
            localStorage.getItem("isAuthenticated") !== null ? (
              <ProfileForm />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/dashboard"
          element={
            localStorage.getItem("isAuthenticated") !== null ? (
              <Dashboard />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/report-issue"
          element={
            localStorage.getItem("isAuthenticated") !== null ? (
              <ReportIssue />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/s/cancel"
          element={
            localStorage.getItem("isAuthenticated") !== null ? (
              <SCancel />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/report-issue-interviewer"
          element={
            localStorage.getItem("isAuthenticated") !== null ? (
              <ReportInterviewer />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/reschedule"
          element={
            localStorage.getItem("isAuthenticated") !== null ? (
              <Reschedule />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/i/cancel"
          element={
            localStorage.getItem("isIAuthenticated") !== null ? (
              <ICancel user={localStorage.getItem("isIAuthenticated")} />
            ) : (
              <Home />
            )
          }
        />
        <Route path="/interviewer/*" element={<Interviewer />} />
        {/* <Route
          path="/interviewer/*"
          element={
            localStorage.getItem("isIAuthenticated") !== null ? (
              <Interviewer />
            ) : (
              <Home />
            )
          }
        /> */}
        <Route path="/student/profile/:id" element={<Int2Std />} />
        {/* <Route path="/interviewer/profile/:id" element={<Std2Int />} /> */}
        <Route path="/std-int" element={<Std2Int />} />

        <Route path="/dump" element={<Dump />} />
      </Routes>
    </div>
  );
}

export default App;
